<template>
<div class="shopMobNavigatorSetting">
    <div class="title">
        <p>图文导航</p>
        <p class="checkCourse">查看教程</p>
    </div>
    <div style="margin-top: 20px">
        <span style="margin-right: 20px">一行显示</span>
        <el-select v-model="item.datacount" placeholder="请选择显示个数">
            <el-option label="3个" :value="3"></el-option>
            <el-option label="4个" :value="4"></el-option>
            <el-option label="5个" :value="5"></el-option>
        </el-select>
    </div>
    <div class="bannerItemBox">
        <SlickList lockAxis="xy" v-model="item.datalist" class="bannerSlickListBox" :distance="5" @input="sortEndList">
            <SlickItem v-for="(obj, index) in item.datalist" :index="index" :key="index" class="bannerSlickItemBox">
                <div class="bannerItem">
                    <div class="bannerBox" @click="openNavigation(obj)" :style="obj.banner.furl?'border-width:0':'border-width:1'">
                        <img :src="obj.banner.furl" alt="">
                    </div>
                    <div class="contentBox">
                        <el-form ref="form" :model="obj" label-width="75px">
                            <el-form-item label="标题">
                                <el-input v-model="obj.objectname" placeholder="请输入标题"></el-input>
                            </el-form-item>
                            <el-form-item label="跳转页面">
                                <el-select v-model="obj.urltype" placeholder="请选择链接页面" @click.native="choiceLink(obj)">
                                    <el-option @click.native="linkPage(index)" v-for="(item, index2) in pageList" :key="index2" :label="item.name" :value="item.code"></el-option>
                                </el-select>
                            </el-form-item>
                            <div class="urlTitle text-ellipse" v-if="obj.urltype==1">
                                <span>页面名称：</span>
                                <span v-if="!!obj.objectdesc"><span v-if="obj.urlname">{{obj.urlname}} | </span>{{obj.objectdesc}}</span>
                            </div>
                            <div class="urlTitle text-ellipse" v-if="obj.urltype==2">
                                <span>商品名称：</span>
                                <span v-if="!!obj.objectdesc">{{obj.kmctypeText}} | {{obj.objectdesc}}</span>
                            </div>
                            <div class="urlTitle text-ellipse" v-if="obj.urltype==5">
                                <span>分组名称：</span>
                                <span v-if="!!obj.objectdesc">{{obj.objectdesc}}</span>
                            </div>
                            <div class="urlTitle text-ellipse" v-if="obj.urltype==7">
                                <span>链接：</span>
                                <span v-if="!!obj.tourl">{{obj.tourl}}</span>
                            </div>
                        </el-form>
                    </div>
                    <i @click="deleteBannerItem(index)" class="el-icon-error"></i>
                </div>
            </SlickItem>
        </SlickList>
    </div>
    <div class="addBox" @click="addBanner">
        <p class="add"><i class="el-icon-circle-plus-outline"></i> 添加导航</p>
    </div>
    <p class="bannerTips">导航总数最多10个</p>
    <navigation ref="navigation"></navigation>
    <banner ref="banner" @setShop='setLink' :index="index" @cancel="cancel"></banner>
    <customLink ref="customLink" @setLink='customLink' @cancel="cancel"></customLink>
    <group ref="group" @setGroup="setGroup" @cancel="cancel"></group>
    <commodity ref="commodity" @setCommodity="setCommodity" @cancel="cancel"></commodity>
</div>
</template>

<script>
import {SlickList, SlickItem} from 'vue-slicksort'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
import Navigation from 'views/shopMgt/mob/page/dataComponents/navigation'
import Banner from '../dataComponents/banner'
import CustomLink from '../dataComponents/customLink'
import Group from '../dataComponents/group'
import Commodity from '../dataComponents/commodity'
// import bannerSetting from '@/'
export default {
    name: 'shopMobNavigatorSetting',
    data() {
        return {
            item: {
                cominnerid: '',
                label: '图文导航',
                comtype: 'categorynav',
                isdisplaytitle: 1,
                titlename: '',
                isdisplayall: 1,
                datasource: 1,
                liststyle: 'detail',
                tagname: '',
                taginnerid: '',
                datacount: 2,
                datalist: [
                    {
                        objectname: '测试图文广告1',
                        urltype: 1,
                        tourl: 'www.baidu.com',
                        linkname: '',
                        kmctype: '',
                        banner: {
                            keyid: '',
                            keyurl: ''
                        }
                    }
                ]
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE',
                attid: '',
                url: ''
            },
            pageList: [
                {code: 1, name: '单个微页面'},
                {code: 2, name: '单个商品'},
                {code: 3, name: '我的消息'},
                {code: 4, name: '我的已购'},
                {code: 5, name: '商品分组'},
                {code: 6, name: '默认微页面'},
                {code: 7, name: '自定义链接'}
            ],
            imgRule: {
                btnName: '修改',
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: 100,
                height: 100
            },
            index: '',
            link: ''
        }
    },
    mounted() {
        this.shopMob.forEach(obj => {
            if (obj.comtype === 'categorynav') {
                this.item = $.extend(true, {}, obj)
            }
        })
    },
    methods: {
        choiceLink(obj) {
            this.link = obj.urltype
        },
        cancel() {
            this.item.datalist[this.index].urltype = this.link
        },
        setGroup(row) {
            this.item.datalist[this.index].urltype = 5
            this.item.datalist[this.index].objectdesc = row.name
            this.item.datalist[this.index].tourl = row.innerid
        },
        setCommodity(datalist) {
            this.item.datalist[this.index].urltype = 2
            this.item.datalist[this.index].linkname = datalist.kmcname
            this.item.datalist[this.index].kmctypeText = datalist.kmctypeText
            this.item.datalist[this.index].objectdesc = datalist.kmcname
            this.item.datalist[this.index].tourl = datalist.kmcinnerid
            this.item.datalist[this.index].kmctype = datalist.kmctype
        },
        setLink(page) {
            this.item.datalist[this.index].tourl = page.innerid
            this.item.datalist[this.index].linkname = page.pagename
            if (page.isdefault) {
                this.item.datalist[this.index].urlname = '主页'
            } else {
                this.item.datalist[this.index].urlname = ''
            }
            this.item.datalist[this.index].objectdesc = page.pagename
            this.item.datalist[this.index].urltype = 1
        },
        customLink(link) {
            this.item.datalist[this.index].linkname = link
            this.item.datalist[this.index].tourl = link
            this.item.datalist[this.index].urltype = 7
        },
        linkPage(v) {
            this.index = v
            this.item.datalist[v].objectdesc = ''
            this.item.datalist[v].urlname = ''
            this.item.datalist[v].tourl = ''
            if (this.item.datalist[v].urltype === 1) {
                this.$refs.banner.openDialog()
            } else if (this.item.datalist[v].urltype === 7) {
                this.$refs.customLink.openDialog()
            } else if (this.item.datalist[v].urltype === 5) {
                this.$refs.group.openDialog([this.item.datalist[this.index]])
            } else if (this.item.datalist[v].urltype === 2) {
                this.$refs.commodity.openDialog()
            }
            // this.item.datalist[v].urltype = ''
        },
        openNavigation(obj) {
            this.$refs.navigation.openDialog(obj)
        },
        sortEndList(list) {
            this.item.datalist = list
        },
        addBanner() {
            this.item.datalist.push({
                contentinnerid: '',
                objectinnerid: '',
                objectname: '',
                banner: {
                    keyid: '',
                    furl: ''
                },
                urltype: '',
                tourl: ''
            })
        },
        deleteBannerItem(index) {
            this.item.datalist.splice(index, 1)
        },
        // 修改banner图
        editBanner() {

        },
        setFile(file) {
            console.log(file)
        },
        ...mapActions([
            'setShopMob'
        ])
    },
    filters: {},
    watch: {
        item: {
            handler: function() {
                let tmpList = $.extend(true, [], this.shopMob)
                let obj = $.extend(true, {}, this.item)
                tmpList.splice(this.selectCom.index, 1, obj)
                this.setShopMob(tmpList)
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    },
    components: {
        SlickList, SlickItem, Navigation, Banner, CustomLink, Group, Commodity
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopMobNavigatorSetting {
    position: absolute;
    top:0;
    left: 102%;
    width: 548px;
    box-sizing: border-box;
    padding: 15px 20px 20px;
    background: #F5F7FA;
    // min-height: 310px;
    border: 1px solid #E4E7ED;
    // height: 0;
    .title{
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;
        border-bottom: 1px solid #DCDFE6;
        .checkCourse{
            color: #409EFF;
            cursor: pointer;
        }
    }
    .bannerTips{
        color: #606266;
        margin-top: 10px;
    }

    .bannerItem{
        width: 508px;
        height: 120px;
        display: flex;
        padding: 20px 10px;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        .bannerBox{
            position: relative;
            width: 90px;
            height: 90px;
            border: 1px solid $line;
            box-sizing: border-box;
            img{
                width: 100%;
                height: 100%;
            }
            .uploadFile{
                .upload-demo{
                    .el-upload{
                        .el-button{
                            position: absolute;
                            top: 0;
                            width: 214px;
                            height: 80px;
                            background: rgba(0,0,0,.4);
                            display: none;
                        }
                    }
                }
            }
        }
        .bannerBox:hover{
            .uploadFile{
                .upload-demo{
                    .el-upload{
                        .el-button{
                            display: block;
                        }
                    }
                }
            }
        }
        .contentBox{
            width: 380px;
            .urlTitle{
                margin-left: 10px;
                color: $tcolor-grey;
                font-size: 14px;
            }
            .el-form-item{
                margin-bottom: 10px;
                .el-form-item__label{
                    font-size: 14px;
                    text-align: left;
                    padding-right: 6px;
                    box-sizing: border-box;
                    text-indent: 12px;
                }
                .el-form-item__content{
                    .el-select{
                        width: 306px;
                    }
                    .el-input__icon{
                        line-height: 32px;
                    }
                }
            }
        }
        .el-icon-error{
            color: #909399;
            position: absolute;
            font-size: 20px;
            top: -10px;
            right: -10px;
            cursor: pointer;
        }
        .el-icon-error:hover{
            color: #409EFF;
        }
    }

    .addBox{
        width: 508px;
        height: 40px;
        border: 1px solid #DCDFE6;
        background: #fff;
        text-align: center;
        margin-top: 15px;
        line-height: 35px;
        font-size: 14px;
        cursor: pointer;
        .add{
            color: #409EFF;
        }
        .addTips{
            color: #909399;
        }
    }
    .el-input__icon{
        line-height: 1;
    }
}
.bannerSlickItemBox{
    margin-top: 20px;
}
.bannerItemBox{
    .bannerItem{
        display: flex;
        border: 1px solid #D8DCE6;
        height: auto;
    }
}
</style>
